import languages from '../languages';

const supportedLanguages = Object.keys(languages).join('|');

export const ROUTE_ABOUT = '/about';
export const ROUTE_DOWNLOAD = '/download';
export const ROUTE_DOWNLOAD_2 = '/download-2';
export const ROUTE_FAQ = '/faq';
export const ROUTE_FEATURE_GOLD = '/feature/gold';
export const ROUTE_FEATURE_PLATINUM = '/feature/platinum';
export const ROUTE_FEATURE_PLUS = '/feature/plus';
export const ROUTE_FEATURE_PREMIUM = '/feature/stand-out';
export const ROUTE_FEATURE_SUBSCRIPTIONS = '/feature/subscription-tiers';
export const ROUTE_FEATURE_SWIPE = '/feature/swipe';
export const ROUTE_FEATURE_SELECT = '/select';
export const ROUTE_PLACE = '/places/:country?/:state?/:city?';
export const ROUTE_PLACES = '/places';
export const ROUTE_GIFT_CARD = '/giftcard';
export const ROUTE_GIFT_CARD_REDEEM = '/giftcard/redeem';

const PREFIX_INTERNATIONAL = `/:lang(${supportedLanguages})`;

const getIntlRouteRegex = (route: string) => `${PREFIX_INTERNATIONAL}?${route}`;

export const HOMEPAGE_INTL_ROUTE_REGEX = getIntlRouteRegex('(/)?');

// page created via gatsby-node
export const STATIC_SITE_DYNAMIC_ROUTES = [ROUTE_PLACE, ROUTE_PLACES];

const STATIC_SITE_ROUTES = [
  ROUTE_ABOUT,
  ROUTE_DOWNLOAD,
  ROUTE_DOWNLOAD_2,
  ROUTE_FAQ,
  ROUTE_FEATURE_GOLD,
  ROUTE_FEATURE_PLATINUM,
  ROUTE_FEATURE_PLUS,
  ROUTE_FEATURE_PREMIUM,
  ROUTE_FEATURE_SUBSCRIPTIONS,
  ROUTE_FEATURE_SWIPE,
  ROUTE_GIFT_CARD,
];

export default STATIC_SITE_ROUTES;

export const STATIC_INTL_ROUTE_REGEXES = STATIC_SITE_ROUTES.concat(
  STATIC_SITE_DYNAMIC_ROUTES
).map<string>(getIntlRouteRegex);
